// Copyright (c) 2017 TrainHeroic LLC
// Actions for Feed

const FEED_ACTIONS = {
    FEED_CARD_LOAD: 'feed-card-load',
    FEED_CARD_ADD_REPLY: 'feed-card-add-reply',
    FEED_IMAGE_UPLOADED: 'feed-image-uploaded',
    FEED_REFRESH: 'feed-refresh',
    FEED_REPLY: 'feed_reply',
    FEED_ACTION: 'feed-action-type',
    FEED_ATHLETE: 'feed-athlete-load',
    FEED_SUMMARY_LOAD: 'feed-summary-load',
    FEED_ATHLETE_AVATAR: 'feed-athlete-avatar',
    DELETE_COMMENT_FEED: 'delete-comment-feed',
    FEED_ITEM_LIKE: 'feed-item-like',
    COMMENT_ADD_DELETE: 'comments-add-delete',
    CALENDAR_LOAD_ATHLETE_SUMMARY: 'calendar-load-athlete-summary',
    CALENDAR_LOAD_ATHLETE_SUMMARY_LAST_COMMENT: 'calendar-last-comment'
};

// merging these because we share the reducer between the calendar and designer
const actions = Object.assign({}, FEED_ACTIONS);
export default actions;
